module.exports = __webpack_public_path__ + "img/join_04.14d2463b.svg";